// extracted by mini-css-extract-plugin
module.exports = {"swatch":"Colors_swatch__5VA1X","color":"Colors_color__31z1j","colorName":"Colors_colorName__VtPKm"};